import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AmanOtpService } from 'src/app/public-website/buyer/services/aman-otp.service';
import { AmanPaymentService } from 'src/app/public-website/buyer/services/aman-payment.service';
import { timer } from 'rxjs';
import { map, take, tap } from 'rxjs/operators';

@Component({
  selector: 'app-aman-installments',
  templateUrl: './aman-installments.component.html',
  styleUrls: ['./aman-installments.component.scss'],
})
export class AmanInstallmentsComponent implements OnInit {
  amanInstallments = [];
  sendCodeClicked: boolean = true;
  sendFailed :string;
  timer: any;
  data;
  nextStep:boolean =true;
  constructor(
    private _formBuilder: FormBuilder,
    private amanOtpService: AmanOtpService,
    private amanPaymentService: AmanPaymentService,
    private router: Router
  ) {
  }
  amanOption = this._formBuilder.group({
    option: ['', [Validators.required]],
  });
  amanOtp = this._formBuilder.group({
    otp: ['', [Validators.required, Validators.pattern(/^(.{6}$|$)/g)]],
  });

  ngOnInit(): void {
    this.data =JSON.parse(localStorage.getItem('amanData'));
    this.amanInstallments = this.data.installmentsOptions;

  }

  async sendOTP() {

    let optionChoose = {
      trxRef: this.data.trxRefNum,
      option: this.amanOption.controls['option'].value,
    };
    this.amanOtpService.setParams(optionChoose);
    await this.amanOtpService.make();

    this.nextStep = false;
    this.sendCodeClicked = false
  }

  async payment() {
    try {
      let paymentBody = {
        trxRef: this.data.trxRefNum,
        otp: this.amanOtp.controls['otp'].value,
      };
      this.amanPaymentService.setParams(paymentBody);
      const res = await this.amanPaymentService.make();
      if (res.data.success === true) {
        this.router.navigate(['gate'], {
          queryParams: {
            refNum: this.data.trxRefNum,
          },
        });
      }
    } catch (err) {
      console.log(err);
      this.sendFailed =err;
    }
    localStorage.removeItem('amanData')
  }

  async reSend() {
    try {
      await this.sendOTP();

      this.sendCodeClicked = true;
      let count = 60;
      this.timer = timer(0, 1000).pipe(
        take(count),
        map(() => --count),
        tap((res) => {
          if (res == 0) this.sendCodeClicked = false;
        })
      );
    } catch (err) {
      console.log(err);
      this.sendFailed = err.message;
    }
  }
}
